import { useState } from "react";
import { addNewArtist } from "../api/write.api";
import { Genre } from "../types/type";
import { Colors } from "../module/constant";

type INewArtist = {
  artistName: string;
  artistImageUrl: string;
  artistDetailImageUrl: string;
  followerIdList: string[];
  songIdList: string[];
  shortIdList: string[];
  homebrewPlaylistIdList: string[];
  tag: {
    genreList: string[];
    tagList: string[];
    [key: string]: any;
  };
  isMale: boolean;
  modelName: string;
};

function AddArtistPage() {
  const [newArtist, setNewArtist] = useState<INewArtist>({
    artistName: "",
    artistImageUrl: "",
    artistDetailImageUrl: "",
    followerIdList: [],
    songIdList: [],
    shortIdList: [],
    homebrewPlaylistIdList: [],
    tag: {
      genreList: [],
      tagList: [],
    },
    isMale: true,
    modelName: "",
  });

  const handleInputChange = (
    field: keyof INewArtist,
    value: string | string[]
  ) => {
    setNewArtist((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleTagChange = (type: "genreList" | "tagList", tag: string) => {
    setNewArtist((prev) => ({
      ...prev,
      tag: {
        ...prev.tag,
        [type]: prev.tag[type].includes(tag)
          ? prev.tag[type].filter((t) => t !== tag)
          : [...prev.tag[type], tag],
      },
    }));
  };

  const handleAddArtist = async () => {
    try {
      await addNewArtist(newArtist);
      // Reset form
      setNewArtist({
        artistName: "",
        artistImageUrl: "",
        artistDetailImageUrl: "",
        followerIdList: [],
        songIdList: [],
        shortIdList: [],
        homebrewPlaylistIdList: [],
        tag: {
          genreList: [],
          tagList: [],
        },
        isMale: true,
        modelName: "",
      });
    } catch (error) {
      console.error("Error adding artist:", error);
      alert("Failed to add artist.");
    }
  };

  return (
    <div>
      <h1>Add New Artist</h1>
      <div>
        <label>Artist Name:</label>
        <input
          type="text"
          value={newArtist.artistName}
          onChange={(e) => handleInputChange("artistName", e.target.value)}
        />
      </div>
      <div>
        <label>Artist Image URL:</label>
        <input
          type="text"
          value={newArtist.artistImageUrl}
          onChange={(e) => handleInputChange("artistImageUrl", e.target.value)}
        />
      </div>
      <div>
        <label>Artist Detail Image URL:</label>
        <input
          type="text"
          value={newArtist.artistDetailImageUrl}
          onChange={(e) =>
            handleInputChange("artistDetailImageUrl", e.target.value)
          }
        />
      </div>
      <div>
        <label>AI Model Name:</label>
        <input
          type="text"
          value={newArtist.modelName}
          onChange={(e) => handleInputChange("modelName", e.target.value)}
          placeholder="Enter model name"
          required
        />
      </div>

      <div>
        <label>Tags (Press Enter to add):</label>
        <input
          type="text"
          onKeyPress={(e) => {
            if (e.key === "Enter" && e.currentTarget.value) {
              handleTagChange("tagList", e.currentTarget.value);
              e.currentTarget.value = "";
            }
          }}
        />
        <div>
          {newArtist.tag.tagList.map((tag, index) => (
            <span key={index} style={{ marginRight: "5px" }}>
              {tag}
            </span>
          ))}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 24,
            backgroundColor: newArtist.isMale ? Colors.ACCENT1 : "transparent",
            cursor: "pointer",
          }}
          onClick={() => setNewArtist((prev) => ({ ...prev, isMale: true }))}
        >
          남자
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 24,
            backgroundColor: !newArtist.isMale ? Colors.ACCENT1 : "transparent",
            cursor: "pointer",
          }}
          onClick={() => setNewArtist((prev) => ({ ...prev, isMale: false }))}
        >
          여자
        </div>
      </div>
      <div>
        <label>Genres:</label>
        {/* Replace these genres with your actual genre values */}
        {Object.values(Genre).map((genre) => (
          <button
            key={genre}
            onClick={() => handleTagChange("genreList", genre)}
            style={{
              backgroundColor: newArtist.tag.genreList.includes(genre)
                ? "lightgreen"
                : "white",
              borderColor: newArtist.tag.genreList.includes(genre)
                ? "green"
                : "grey",
              borderWidth: 0.1,
              marginRight: 4,
            }}
          >
            {genre}
          </button>
        ))}
      </div>
      <button type="button" onClick={handleAddArtist}>
        Add Artist
      </button>
    </div>
  );
}

export default AddArtistPage;
